export default {
  path: 'edit-project',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Edit Project',
      component: () => import('@/views/menus/editProject/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
